import React, { useState } from 'react';
import { ManualPortfolioPosition } from '../../stores/portfolioStore';

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (pos: ManualPortfolioPosition) => void;
  initial?: ManualPortfolioPosition;
}

export const ManualAssetModal: React.FC<Props> = ({ open, onClose, onSave, initial }) => {
  const [assetId, setAssetId] = useState(initial?.assetId || '');
  const [quantity, setQuantity] = useState(initial?.quantity?.toString() || '');
  const [price, setPrice] = useState(initial?.price?.toString() || '');

  if (!open) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0008', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 340, boxShadow: '0 2px 16px #0002' }}>
        <h2 style={{ marginTop: 0 }}>{initial ? 'Edit Manual Asset' : 'Add Manual Asset'}</h2>
        <div style={{ marginBottom: 16 }}>
          <label>Asset Symbol</label>
          <input value={assetId} onChange={e => setAssetId(e.target.value.toUpperCase())} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #bbb', marginTop: 4 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Quantity</label>
          <input type="number" value={quantity} onChange={e => setQuantity(e.target.value)} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #bbb', marginTop: 4 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Price (USD, optionnel)</label>
          <input type="number" value={price} onChange={e => setPrice(e.target.value)} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #bbb', marginTop: 4 }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button onClick={onClose} style={{ padding: '8px 18px', borderRadius: 6, border: 'none', background: '#eee', color: '#333', fontWeight: 500 }}>Cancel</button>
          <button
            onClick={() => {
              console.log('[ManualAssetModal] Save click: assetId=', assetId, 'quantity=', quantity, 'price=', price);
              if (!assetId || !quantity) {
                console.log('[ManualAssetModal] assetId ou quantity manquant');
                return;
              }
              if (typeof window !== 'undefined') {
                console.log('[ManualAssetModal] window.cryptoTable:', window.cryptoTable);
              }
              // Force la récupération de la table des prix si le prix est absent ou à 0
              function saveManualAsset() {
                let injectedPrice: number | undefined = undefined;
                if (price && !isNaN(Number(price))) {
                  injectedPrice = Number(price);
                  if (assetId.toUpperCase() === 'BTC') {
                    console.log('[ManualAssetModal][BTC] Prix saisi manuellement:', injectedPrice);
                  }
                } else if (typeof window !== 'undefined' && Array.isArray(window.cryptoTable)) {
                  const found = window.cryptoTable.find((c: any) => c.symbol.toUpperCase() === assetId.toUpperCase());
                  injectedPrice = found && typeof found.priceUsd === 'number' ? found.priceUsd : undefined;
                  if (assetId.toUpperCase() === 'BTC') {
                    console.log('[ManualAssetModal][BTC] Prix injecté depuis cryptoTable:', injectedPrice, 'objet:', found);
                  }
                }
                if (assetId.toUpperCase() === 'BTC') {
                  console.log('[ManualAssetModal][BTC] AssetId:', assetId, 'Quantity:', quantity, 'InjectedPrice:', injectedPrice);
                }
                onSave({
                  id: initial?.id || Math.random().toString(36).slice(2),
                  assetId,
                  quantity: parseFloat(quantity),
                  price: injectedPrice,
                  sourceType: 'MANUAL',
                });
                if (assetId.toUpperCase() === 'BTC') {
                  console.log('[ManualAssetModal][BTC] onSave appelé pour BTC avec price', injectedPrice);
                }
              }
              if (typeof window !== 'undefined') {
                let found = Array.isArray(window.cryptoTable)
                  ? window.cryptoTable.find((c: any) => c.symbol.toUpperCase() === assetId.toUpperCase())
                  : undefined;
                let foundPrice = found ? found.priceUsd ?? 0 : 0;
                if ((!window.cryptoTable || !Array.isArray(window.cryptoTable) || window.cryptoTable.length === 0) || (!price && foundPrice === 0)) {
                  console.log('[ManualAssetModal] window.cryptoTable vide ou prix absent/0, fetch /api/cryptos...');
                  fetch('/api/cryptos')
                    .then(res => res.json())
                    .then(data => {
                      let arr = Array.isArray(data.content) ? data.content : Array.isArray(data) ? data : [];
                      window.cryptoTable = arr.map((c: any) => ({ symbol: c.symbol, priceUsd: c.priceUsd ?? 0 }));
                      localStorage.setItem('ecotoneai_cryptoTable', JSON.stringify(window.cryptoTable));
                      console.log('[ManualAssetModal] window.cryptoTable après fetch:', window.cryptoTable);
                      found = Array.isArray(window.cryptoTable)
                        ? window.cryptoTable.find((c: any) => c.symbol.toUpperCase() === assetId.toUpperCase())
                        : undefined;
                      foundPrice = found ? found.priceUsd ?? 0 : 0;
                      if (!found || foundPrice === 0) {
                        console.log('[ManualAssetModal] asset', assetId, 'absent ou prix=0 dans la table des prix');
                        alert('L\'asset ' + assetId + ' n\'est pas présent ou prix=0 dans la table des prix. Veuillez synchroniser ou saisir un prix manuellement.');
                        return;
                      }
                      console.log('[ManualAssetModal] asset', assetId, 'trouvé dans la table des prix avec prix', foundPrice);
                      saveManualAsset();
                    });
                  return;
                }
                if (!price && (!found || foundPrice === 0)) {
                  console.log('[ManualAssetModal] asset', assetId, 'absent ou prix=0 dans la table des prix');
                  alert('L\'asset ' + assetId + ' n\'est pas présent ou prix=0 dans la table des prix. Veuillez synchroniser ou saisir un prix manuellement.');
                  return;
                }
                console.log('[ManualAssetModal] asset', assetId, 'trouvé dans la table des prix avec prix', foundPrice);
              }
              saveManualAsset();
            }}
            style={{ padding: '8px 18px', borderRadius: 6, border: 'none', background: '#1976d2', color: '#fff', fontWeight: 600 }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
